import { ChangeDetectionStrategy, Component, computed, ElementRef, HostListener, inject, input, model } from '@angular/core';

import { LayoutService } from '@shared/services';

/**
 * Top-bar popover shell: trigger, caret, and panel used by the account menu.
 */
@Component({
  selector: 'pulse-topbar-menu',
  templateUrl: './pulse-topbar-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'topbar-menu',
    '[class.topbar-menu--open]': 'open()'
  }
})
export class PulseTopbarMenuComponent {
  private host = inject(ElementRef<HTMLElement>);
  private layoutService = inject(LayoutService);

  /** Whether the popover panel is open. */
  open = model(false);

  /** Accessible name for the trigger button. */
  ariaLabel = input.required<string>();

  /** Extra classes for the popover panel (e.g. account-menu modifiers). */
  panelClass = input('');

  protected panelHostClass = computed(() => {
    const extra = this.panelClass().trim();
    return extra ? `topbar-menu__panel ${extra}` : 'topbar-menu__panel';
  });

  toggle(): void {
    this.open.update((isOpen) => !isOpen);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.layoutService.isMobileLayout() || !this.open()) {
      return;
    }

    if (this.host.nativeElement.contains(event.target as Node)) {
      return;
    }

    this.open.set(false);
  }

  @HostListener('document:keydown.escape')
  onEscapeKeydown(): void {
    if (this.open()) {
      this.open.set(false);
    }
  }
}
